"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PaymentTab_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTab = void 0;
require("./payment.less");
const React = require("react");
const moment = require("moment-timezone");
const payment_1 = require("shared/payment");
const claim_1 = require("shared/claim");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field/text-field");
const form_1 = require("client/components/ui/form");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/orders/store");
const store_2 = require("./store");
const react_credit_cards_1 = require("react-credit-cards"); //D-002
require("react-credit-cards/es/styles-compiled.css"); //D-002
require("./payment.css"); //D-002
const confirmation_modal_1 = require("client/components/confirmation-modal"); //D-002
const tostify_alert_1 = require("../../../../../../components/tostify-alert/tostify-alert"); // D-002
const cc_tokenizer_frame_1 = require("./cc-tokenizer-frame");
const toolbar_1 = require("client/components/material/toolbar"); // D-002.60
const store_3 = require("client/modules/users/store"); // D-002.60
const modal_1 = require("client/components/modal"); //D-002.611
const store_4 = require("../../../../../../modules/patients/store"); //D-002.611
const store_5 = require("../../../../../../modules/inventory-order/store");
const patient_payment_balance_1 = require("shared/patient-payment-balance");
const columns = [
    {
        id: "method",
        label: "Payment Type",
        numeric: false,
        className: "payment__col payment__col--type"
    },
    {
        id: "datePaid",
        label: "Date Paid",
        numeric: false,
        className: "payment__col payment__col--date"
    },
    {
        id: "amountPaid",
        label: "Amount Paid",
        numeric: true,
        className: "payment__col payment__col--amount"
    },
    {
        id: "cardEnding",
        label: "Card Ending",
        numeric: true,
        className: "payment__col payment__col--card"
    },
    {
        id: "transaction",
        label: "Transaction No",
        numeric: true,
        className: "payment__col payment__col--txn"
    },
    {
        id: "responseEnding",
        label: "Response Ending",
        numeric: false,
        className: "payment__col payment__col--response"
    },
    {
        id: "checkNo",
        label: "Check #",
        numeric: false,
        className: "payment__col payment__col--check"
    },
    {
        id: "notes",
        label: "Notes",
        numeric: false,
        className: "payment__col payment__col--notes"
    },
    {
        id: "actions",
        label: "Actions",
        numeric: false,
        className: "payment__col payment__col--actions payment__table--actions-header"
    }
];
const getPaymentTableColumns = (hideResponseEnding) => hideResponseEnding
    ? columns.filter((column) => column.id !== "responseEnding")
    : columns;
const dummyQuery = {
    email: "",
    receiptPdfFile: "",
    patName: "",
    siteName: ""
};
const normalizeBillingPostal = (value) => String(value || "").replace(/\D/g, "").slice(0, 9);
let PaymentTab = PaymentTab_1 = class PaymentTab extends React.Component {
    // D-002 constructor fn
    constructor(props) {
        var _a, _b;
        super(props);
        this.dummyPayment = {
            amountPaid: 0,
            cardEnding: null,
            cardType: null,
            checkNumber: null,
            claimId: null,
            notes: null,
            datePaid: new Date(),
            method: payment_1.PaymentMethod.credit,
            orderId: null,
            siteId: null,
            sitePay: null,
            responseEnding: null
        };
        this.claims = new Set();
        this.paymentNotes = {}; //D-002.839
        /** D-002.592 — dollars string per claim when Amount Paid < Balance Due */
        this.claimAmounts = {};
        this.patProfileId = "0"; //D-002.53
        this.payment = this.dummyPayment;
        this.balance = null;
        this.openConfirmationModal = false; // D-002
        this.checked = false; // D-002.611
        this.isValidEmail = false; // D-002.611
        this.showModal = false; // D-002.611
        this.deleteConfirmation = false; // D-002_new
        this.refundConfirmation = false; // D-002.840
        this.refundRowId = null; // D-002.840
        this.refundAmountCents = 0; // D-002.840
        this.savedCardDeleteConfirmation = false;
        this.savedCardDeleteSubmitting = false;
        this.savedCardToDelete = null;
        this.cardTypeName = ""; // D-002
        this.allowCardConnectPatientPay = false; // D-002
        /** D-002 Phase 3 — Hosted iFrame Tokenizer */
        this.ccTokenizerIframeUrl = "";
        this.tokenizerResetKey = 0;
        this.chargeIdempotencyKey = ""; // D-002 charge hardening
        this.cardPaymentSubmitting = false; // D-002 charge hardening
        this.printModal = false; // D-002.60
        this.pageSettings = {
            error: "",
            firstLoad: true,
            loaded: false,
            showPay: false
        };
        this.toastRef = React.createRef(); // D-002
        this.availableMethods = Object.values(payment_1.PaymentMethod).map((method, i) => ({
            id: i,
            label: method,
            value: method
        }));
        this.availableCards = Object.values(payment_1.CardType).map((card, i) => ({
            id: i,
            label: card,
            value: card
        }));
        /** Each Rx is its own list. A drag updates one list; this copies those widths to the others. */
        this.paymentTablesEl = null;
        this.paymentColumnSource = null;
        this.rememberPaymentColumnDrag = (event) => {
            const target = event.target;
            if (!target || !target.classList.contains("resizable-table-cursor-resize")) {
                this.paymentColumnSource = null;
                return;
            }
            const table = target.closest(".paymentoutstanding-table");
            const list = table && table.querySelector(".list ul");
            this.paymentColumnSource = list;
        };
        this.syncPaymentColumnWidths = () => {
            const root = this.paymentTablesEl;
            const source = this.paymentColumnSource;
            this.paymentColumnSource = null;
            if (!root || !source || !root.contains(source))
                return;
            const tables = root.querySelectorAll(".paymentoutstanding-table .list ul");
            if (tables.length < 2)
                return;
            const header = source.querySelector("li.resizable-header") || source.querySelector("li");
            if (!header)
                return;
            const bases = Array.from(header.children).map(cell => cell.style.flexBasis);
            if (!bases.some(Boolean))
                return;
            tables.forEach(ul => {
                if (ul === source)
                    return;
                ul.querySelectorAll("li").forEach(row => {
                    Array.from(row.children).forEach((cell, index) => {
                        if (bases[index]) {
                            cell.style.flexBasis = bases[index];
                        }
                    });
                });
            });
        };
        this.populateOrder = async () => {
            var _a, _b, _c, _d, _e, _f, _g;
            const orderId = Number(this.props.params[0]);
            if (!this.props.order) {
                await store_1.ordersStore.readOrder(orderId);
            }
            this.order = this.props.order || store_1.ordersStore.order.value;
            const companyInfo = await store_5.inventoryOrderStore.loadSiteComapnyDetailsInfo(this.order.site.id);
            const allowSiteCopayCollection = !!((_a = this.order.site) === null || _a === void 0 ? void 0 : _a.allowSiteCopayCollection);
            const allowCompanyCopayCollection = companyInfo[0].allowCompanyCopayCollection == 1;
            this.allowCardConnectPatientPay = patient_payment_balance_1.isCopayCollectionEnabled(allowSiteCopayCollection, allowCompanyCopayCollection);
            if (this.allowCardConnectPatientPay) {
                await store_1.ordersStore.refreshOrderDetail(orderId, false);
                this.order = store_1.ordersStore.order.value;
                const tokCfg = await store_2.paymentsStore.readCcTokenizerConfig();
                this.ccTokenizerIframeUrl = (tokCfg && tokCfg.iframeUrl) || "";
            }
            else {
                this.ccTokenizerIframeUrl = "";
            }
            if (!this.state.billingPostal) {
                this.setState({
                    billingPostal: normalizeBillingPostal((_c = (_b = this.order) === null || _b === void 0 ? void 0 : _b.patient) === null || _c === void 0 ? void 0 : _c.zip)
                });
            }
            this.chargeClaims = this.order.claims.filter((claim) => patient_payment_balance_1.PAYABLE_CLAIM_STATUSES.includes(claim.status));
            this.payment.orderId = this.order.id;
            let payments = patient_payment_balance_1.collectPaymentsFromClaims(this.order.claims);
            if (!payments.length) {
                payments = await store_2.paymentsStore.readPayments(orderId);
                // Keep header isPaymentComplete in sync when claim.payments were missing
                // (e.g. after loadClaims orderData without payments).
                const byClaimId = new Map();
                for (const payment of payments) {
                    if (payment.claimId == null)
                        continue;
                    const list = byClaimId.get(payment.claimId) || [];
                    list.push(payment);
                    byClaimId.set(payment.claimId, list);
                }
                for (const claim of this.order.claims || []) {
                    claim.payments = (byClaimId.get(claim.id) || []);
                }
                if (((_d = store_1.ordersStore.order.value) === null || _d === void 0 ? void 0 : _d.id) === this.order.id) {
                    store_1.ordersStore.order.value.claims = this.order.claims;
                }
            }
            this.order.payments = payments;
            this.calculateBalance();
            this.payment.amountPaid = this.toUSD(this.balance.due).replace(/[$,]/g, "");
            this.patCardProfile =
                (await store_2.paymentsStore.readProfileByPatient((_e = this.order) === null || _e === void 0 ? void 0 : _e.patient.id, (_g = (_f = this.order) === null || _f === void 0 ? void 0 : _f.site) === null || _g === void 0 ? void 0 : _g.id)) || []; //D-002.53
            this.pageSettings.loaded = true;
        };
        this.handleChangeNumber = (event, value) => {
            if (!(value === "" || PaymentTab_1.MONEY_INPUT_REGEX.test(value)))
                return;
            this.payment.amountPaid = value;
            // D-002.592 — clear per-Rx amounts when returning to full balance pay
            if (!this.needsManualAllocation) {
                this.claimAmounts = {};
            }
            else {
                this.clampClaimAmountsToLimits();
            }
        };
        this.getClaimRemainingDueCents = (claim) => {
            var _a;
            const claimPayments = (((_a = this.order) === null || _a === void 0 ? void 0 : _a.payments) || []).filter((payment) => payment.claimId === claim.id);
            const claimDueCents = patient_payment_balance_1.getClaimAmountDueCents(claim);
            const totalPaid = claimPayments.reduce((acc, cur) => acc + patient_payment_balance_1.netPaymentAmountCents(cur), 0);
            return Math.max(0, claimDueCents - totalPaid);
        };
        /** Max for one Rx: min(claim due, Amount Paid left after other Rxs). */
        this.getMaxApplyCentsForClaim = (claimId) => {
            const claim = (this.chargeClaims || []).find((c) => c.id === claimId);
            if (!claim)
                return 0;
            const remainingDue = this.getClaimRemainingDueCents(claim);
            const paidCents = patient_payment_balance_1.dollarsToCents(this.payment.amountPaid);
            let otherApply = 0;
            for (const id of Array.from(this.claims)) {
                if (id === claimId)
                    continue;
                const raw = this.claimAmounts[id];
                if (raw == null || raw === "" || String(raw).endsWith("."))
                    continue;
                otherApply += patient_payment_balance_1.dollarsToCents(raw);
            }
            return Math.min(remainingDue, Math.max(0, paidCents - otherApply));
        };
        this.centsToDollarInput = (cents) => (Math.max(0, cents) / 100).toFixed(2);
        this.clampClaimAmountsToLimits = () => {
            const paidCents = patient_payment_balance_1.dollarsToCents(this.payment.amountPaid);
            const next = Object.assign({}, this.claimAmounts);
            let changed = false;
            for (const claim of this.chargeClaims || []) {
                const raw = next[claim.id];
                if (raw == null || raw === "" || String(raw).endsWith("."))
                    continue;
                const cents = patient_payment_balance_1.dollarsToCents(raw);
                const maxCents = Math.min(this.getClaimRemainingDueCents(claim), paidCents);
                if (cents > maxCents) {
                    next[claim.id] =
                        maxCents < 1 ? "" : this.centsToDollarInput(maxCents);
                    changed = true;
                }
            }
            if (changed)
                this.claimAmounts = next;
        };
        this.isClaimAmountInvalid = (claimId) => {
            if (!this.claims.has(claimId))
                return false;
            const raw = this.claimAmounts[claimId];
            if (raw == null || raw === "" || String(raw).endsWith("."))
                return false;
            const amountCents = patient_payment_balance_1.dollarsToCents(raw);
            if (amountCents < 1)
                return true;
            const claim = (this.chargeClaims || []).find((c) => c.id === claimId);
            if (!claim)
                return false;
            const maxCents = Math.min(this.getClaimRemainingDueCents(claim), patient_payment_balance_1.dollarsToCents(this.payment.amountPaid));
            return amountCents > maxCents;
        };
        this.handleClaimAmountChange = (claimId, value) => {
            // Reject negatives / non-money (old regex used `.` as any char, so "-1" passed)
            if (!(value === "" || PaymentTab_1.MONEY_INPUT_REGEX.test(value)))
                return;
            // Allow empty and in-progress typing ("12.")
            if (value === "" || value.endsWith(".")) {
                this.claimAmounts = Object.assign(Object.assign({}, this.claimAmounts), { [claimId]: value });
                this.pageSettings.error = "";
                this.forceUpdate();
                return;
            }
            const amountCents = patient_payment_balance_1.dollarsToCents(value);
            const maxCents = this.getMaxApplyCentsForClaim(claimId);
            if (amountCents > maxCents) {
                this.claimAmounts = Object.assign(Object.assign({}, this.claimAmounts), { [claimId]: maxCents < 1 ? "" : this.centsToDollarInput(maxCents) });
                this.pageSettings.error =
                    maxCents < 1
                        ? "Amount to Apply cannot exceed the balance due for that claim or the Amount Paid."
                        : "";
                this.forceUpdate();
                return;
            }
            this.claimAmounts = Object.assign(Object.assign({}, this.claimAmounts), { [claimId]: value });
            if (amountCents < 1) {
                this.pageSettings.error =
                    "Amount to Apply must be at least $0.01 (leave blank to skip this claim).";
            }
            else {
                this.pageSettings.error = "";
            }
            this.forceUpdate();
        };
        this.handleClaimAmountBlur = (claimId) => {
            const raw = this.claimAmounts[claimId];
            if (raw == null || raw === "")
                return;
            // Drop trailing decimal leftover from typing
            if (String(raw).endsWith(".")) {
                const trimmed = String(raw).slice(0, -1);
                this.claimAmounts = Object.assign(Object.assign({}, this.claimAmounts), { [claimId]: trimmed });
            }
            const current = this.claimAmounts[claimId];
            const amountCents = patient_payment_balance_1.dollarsToCents(current || 0);
            // Empty / $0 is allowed (skip that Rx); clear invalid zero / sub-cent entry
            if (current !== "" && amountCents < 1) {
                const next = Object.assign({}, this.claimAmounts);
                delete next[claimId];
                this.claimAmounts = next;
                this.pageSettings.error =
                    "Amount to Apply must be at least $0.01 (leave blank to skip this claim).";
                this.forceUpdate();
            }
        };
        /**
         * D-002 Handle payment methods
         * @param value
         */
        this.handleOnSelect = async (value) => {
            if (value) {
                this.payment.method = value;
                // These belong to the method being left behind; without this a check
                // number typed first would still be saved on a cash payment.
                this.payment.checkNumber = null;
                this.payment.cardType = null;
                this.payment.cardEnding = null;
                this.payment.responseEnding = null;
                this.setState({
                    cardnumber: "",
                    cardholdername: "",
                    expiry: "",
                    cvc: "",
                    focus: false,
                    saveCard: false,
                    nickName: "",
                    cardToken: "",
                    tokenizerError: ""
                });
                this.cardTypeName = "";
                this.patProfileId = "0";
                this.tokenizerResetKey = Date.now();
            }
        };
        /**
         * D-002.53 Handle patient payment profile
         * @param value
         */
        this.handlePrfOnSelect = async (id) => {
            this.patProfileId = id;
            if (id === "0") {
                this.cardTypeName = "";
            }
            this.patCardProfile.map((pro) => {
                if (pro.profileId === id) {
                    this.setState({
                        cardnumber: pro.account.split("X").join("*"),
                        cardholdername: pro.acctHolderName,
                        expiry: pro.expiry,
                        acctId: pro.acctId
                    });
                    this.cardTypeName = pro.acctType;
                }
            });
            if (id)
                this.setState({ cvc: "", saveCard: false, nickName: "", cardToken: "", tokenizerError: "" });
        };
        this.resetSavedCardSelection = () => {
            this.patProfileId = "0";
            this.cardTypeName = "";
            this.setState({
                cardholdername: "",
                cardnumber: "",
                expiry: "",
                cvc: "",
                acctId: "",
                saveCard: false,
                cardToken: "",
                tokenizerError: ""
            });
            this.tokenizerResetKey = Date.now();
        };
        this.openSavedCardDeleteModal = () => {
            const selected = (this.patCardProfile || []).find(profile => profile.profileId === this.patProfileId &&
                profile.acctId === this.state.acctId);
            if (!selected || this.cardPaymentSubmitting)
                return;
            this.savedCardToDelete = selected;
            this.savedCardDeleteConfirmation = true;
        };
        this.closeSavedCardDeleteModal = () => {
            if (this.savedCardDeleteSubmitting)
                return;
            this.savedCardDeleteConfirmation = false;
            this.savedCardToDelete = null;
        };
        this.savedCardDeleteMessage = () => {
            var _a, _b;
            const brand = String(((_a = this.savedCardToDelete) === null || _a === void 0 ? void 0 : _a.acctType) || "Card")
                .replace(/[^A-Za-z0-9 ]/g, "")
                .trim() || "Card";
            const ending = String(((_b = this.savedCardToDelete) === null || _b === void 0 ? void 0 : _b.cardEnding) || "")
                .replace(/\D/g, "")
                .slice(-4);
            const card = ending ? `${brand} ending in ${ending}` : brand;
            return `Remove <b>${card}</b> for this patient at this pharmacy?<br />Past payments and refunds will not be affected.`;
        };
        this.handleSavedCardDelete = async () => {
            var _a, _b, _c;
            const selected = this.savedCardToDelete;
            if (!selected || this.savedCardDeleteSubmitting)
                return;
            this.savedCardDeleteSubmitting = true;
            try {
                const result = await store_2.paymentsStore.deleteSavedCard(selected.id, this.order.id);
                if ("error" in result) {
                    (_a = this.toastRef.current) === null || _a === void 0 ? void 0 : _a.notifyError(result.message || "Unable to remove the saved card.");
                    return;
                }
                // The endpoint also removes exact duplicate local rows after CardPointe
                // confirms deletion, so mirror that result without another round trip.
                this.patCardProfile = (this.patCardProfile || []).filter(profile => profile.profileId !== selected.profileId ||
                    profile.acctId !== selected.acctId);
                this.resetSavedCardSelection();
                this.savedCardDeleteConfirmation = false;
                this.savedCardToDelete = null;
                (_b = this.toastRef.current) === null || _b === void 0 ? void 0 : _b.notifySuccess("Saved card removed.");
            }
            catch (_d) {
                (_c = this.toastRef.current) === null || _c === void 0 ? void 0 : _c.notifyError("Unable to remove the saved card. Please try again.");
            }
            finally {
                this.savedCardDeleteSubmitting = false;
            }
        };
        this.remountTokenizer = () => {
            this.tokenizerResetKey = Date.now();
            this.setState({ cardToken: "", tokenizerError: "" });
        };
        this.isExpiredTokenDecline = (resptext) => {
            const t = String(resptext || "").toLowerCase();
            if (!t)
                return false;
            if (t.includes("token") && (t.includes("expir") || t.includes("invalid") || t.includes("not found"))) {
                return true;
            }
            return t.includes("card entry timed out") || t.includes("please re-enter");
        };
        this.checkErrors = () => {
            const { expiry, billingPostal } = this.state;
            this.pageSettings.error = "";
            const selectedTotal = this.order.claims.reduce((acc, cur) => {
                if (this.claims.has(cur.id))
                    return acc + patient_payment_balance_1.getClaimAmountDueCents(cur);
                return acc;
            }, 0);
            const selectedPaid = this.order.payments.reduce((acc, cur) => {
                if (this.claims.has(cur.claimId))
                    return acc + patient_payment_balance_1.netPaymentAmountCents(cur);
                return acc;
            }, 0);
            const selectedDue = selectedTotal - selectedPaid;
            const totalSubmitted = patient_payment_balance_1.dollarsToCents(this.payment.amountPaid);
            //D-002 apply card expiry validation
            const date = new Date();
            const year = date.getFullYear().toString();
            const month = date.getMonth() + 1;
            const currMonth = month.toString();
            const currYear = year.slice(-2);
            const currMMYY = currMonth + currYear;
            const cardExpiryYear = (expiry !== null && expiry !== void 0 ? expiry : "").slice(-2);
            const error = {
                noClaim: "Unable to submit blank payment, please select a claim.",
                noValue: "Please enter a value greater than zero.",
                tooMuchClaims: "Payment entered is larger than total price due on selected claims",
                tooMuchOrder: "Unable to process payment larger than balance due.",
                cardExpired: "Unable to submit a payment with expired card.",
                invalidBillingPostal: "Enter the 5 or 9 digit billing ZIP associated with the card.",
                allocationMismatch: "Total to Apply must equal Amount Paid.",
                invalidClaimAmount: "Amount to Apply must be at least $0.01 and cannot exceed the balance due for that claim or the Amount Paid."
            };
            if (selectedDue < totalSubmitted)
                this.pageSettings.error = error.tooMuchClaims;
            if (!totalSubmitted)
                this.pageSettings.error = error.noValue;
            if (!this.claims.size)
                this.pageSettings.error = error.noClaim;
            if (totalSubmitted > this.balance.due)
                this.pageSettings.error = error.tooMuchOrder;
            // D-002.592 — partial payment requires per-Rx Amount to Apply
            if (this.needsManualAllocation) {
                if (!this.isAllocationComplete) {
                    this.pageSettings.error = error.allocationMismatch;
                }
                for (const claim of this.chargeClaims || []) {
                    if (!this.claims.has(claim.id))
                        continue;
                    const raw = this.claimAmounts[claim.id];
                    if (raw == null || raw === "" || String(raw).endsWith("."))
                        continue;
                    const amountCents = patient_payment_balance_1.dollarsToCents(raw);
                    const remainingDue = this.getClaimRemainingDueCents(claim);
                    const maxCents = Math.min(remainingDue, totalSubmitted);
                    if (amountCents < 1 || amountCents > maxCents) {
                        this.pageSettings.error = error.invalidClaimAmount;
                        break;
                    }
                }
            }
            // D-002.57 — expiry is validated inside the CardPointe iframe when tokenizer is on
            if (this.payment.method === payment_1.PaymentMethod.credit &&
                this.allowCardConnectPatientPay) {
                if (!this.usesTokenizer) {
                    if (currYear > cardExpiryYear)
                        this.pageSettings.error = error.cardExpired;
                    if (currYear == cardExpiryYear) {
                        if (Number(currMMYY) > Number(expiry))
                            this.pageSettings.error = error.cardExpired;
                    }
                }
                else if (!this.state.cardToken) {
                    this.pageSettings.error =
                        this.state.tokenizerError ||
                            "Enter card details in the secure card form before submitting.";
                }
                if (!/^\d{5}(\d{4})?$/.test(billingPostal || ""))
                    this.pageSettings.error = error.invalidBillingPostal;
            }
        };
        /**
         * handle save card checkbox
         * @param event D-002.53
         */
        this.handleSaveCard = (event) => {
            this.setState({
                saveCard: event.target.checked,
                nickName: ""
            });
        };
        /**
         * D-002 handle Confirmation Pop Up
         */
        this.handleConfirmationPopUp = async () => {
            this.checkErrors();
            if (!this.pageSettings.error) {
                this.openConfirmationModal = !this.openConfirmationModal;
            }
        };
        /**
         * D-002 D-002.58 handle payment confirmation onClick and organized the payload
         */
        this.handleSubmit = async () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (this.payment.method === payment_1.PaymentMethod.credit &&
                this.allowCardConnectPatientPay &&
                this.cardPaymentSubmitting) {
                return;
            }
            const { cardholdername, expiry, cvc, billingPostal, saveCard, nickName, cardnumber, acctId } = this.state;
            let siteRefNumber = 0;
            if ((_b = (_a = this.order) === null || _a === void 0 ? void 0 : _a.site) === null || _b === void 0 ? void 0 : _b.id) {
                let data = await store_2.paymentsStore.readPaymentsBySite((_d = (_c = this.order) === null || _c === void 0 ? void 0 : _c.site) === null || _d === void 0 ? void 0 : _d.id);
                siteRefNumber = data.length ? data[data.length - 1].sitePay : 0;
            }
            let claims = Array.from(this.claims);
            let payment = Object.assign({}, this.payment);
            let profileID = this.patProfileId;
            let acctID = acctId;
            // D-002.74 — server stamps datePaid with full datetime; client date is display-only
            payment.datePaid = moment.tz(this.getSiteTimezone()).toDate();
            payment.amountPaid = patient_payment_balance_1.dollarsToCents(payment.amountPaid);
            payment.orderId = this.order.id;
            payment.sitePay = siteRefNumber + 1;
            payment.cardHolderName = cardholdername;
            payment.notes = this.paymentNotes; //D-002.839
            payment.billingPostal = normalizeBillingPostal(billingPostal);
            payment.nickName = saveCard ? nickName : "";
            payment.siteId = (_f = (_e = this.order) === null || _e === void 0 ? void 0 : _e.site) === null || _f === void 0 ? void 0 : _f.id;
            payment.patientId = (_g = this.order) === null || _g === void 0 ? void 0 : _g.patient.id;
            payment.profile = saveCard ? "Y" : "N";
            // CardConnect card type is resolved server-side from the authorization
            // receipt's Network Label; never trust stale client state for persistence.
            payment.cardType = this.allowCardConnectPatientPay
                ? null
                : (_h = this.payment.cardType) !== null && _h !== void 0 ? _h : payment_1.CardType.visa;
            // D-002 Phase 3 — Hosted iFrame Tokenizer: send token, never PAN
            if (this.usesTokenizer) {
                payment.cardToken = this.state.cardToken || "";
                payment.cardNumber = "";
                payment.cardExpiry = "";
                payment.cardCvv = "";
            }
            else {
                payment.cardToken = undefined;
                payment.cardNumber = cardnumber;
                payment.cardExpiry = expiry;
                payment.cardCvv = cvc;
            }
            if (this.payment.method === payment_1.PaymentMethod.credit &&
                this.allowCardConnectPatientPay &&
                !this.chargeIdempotencyKey) {
                this.chargeIdempotencyKey = this.newChargeIdempotencyKey();
            }
            // D-002.592 — send per-claim cents when Amount Paid < Balance Due
            let claimAmounts;
            if (this.needsManualAllocation) {
                claimAmounts = {};
                claims = [];
                for (const claimId of Array.from(this.claims)) {
                    const cents = patient_payment_balance_1.dollarsToCents(this.claimAmounts[claimId] || 0);
                    if (cents > 0) {
                        claims.push(claimId);
                        claimAmounts[claimId] = cents;
                    }
                }
            }
            let payObj = {
                claims,
                payment,
                profileID,
                acctID,
                idempotencyKey: this.chargeIdempotencyKey || undefined,
                claimAmounts
            };
            this.checkErrors();
            if (this.pageSettings.error)
                return;
            this.paymentNotes = {}; //D-002.839
            if (this.payment.method === payment_1.PaymentMethod.credit &&
                this.allowCardConnectPatientPay) {
                await this.handleOnlinePayment(payObj);
            }
            else {
                await this.handleManualPayment(payObj);
            }
        };
        /**
         * this function handle online payment through payment gateway D-002
         * @param payObj
         */
        this.handleOnlinePayment = async (payObj) => {
            if (this.cardPaymentSubmitting)
                return;
            this.cardPaymentSubmitting = true;
            this.pageSettings.loaded = false;
            try {
                const result = await store_2.paymentsStore.createCardPayment(payObj);
                this.openConfirmationModal = false;
                if (result.success) {
                    const paymentData = result.data;
                    this.chargeIdempotencyKey = "";
                    const isApproved = paymentData.respstat === "A";
                    const declineText = paymentData.resptext ||
                        "Payment has declined due to invalid card credentials.";
                    const tokenExpired = !isApproved &&
                        this.usesTokenizer &&
                        this.isExpiredTokenDecline(declineText);
                    if (isApproved) {
                        this.resetProperties();
                        await this.populateOrder();
                        this.pageSettings.loaded = true;
                        this.toastRef.current.notifySuccess("Payment has been successfully completed.");
                    }
                    else if (tokenExpired) {
                        // Keep the payment form open; CardSecure tokens last ~2 minutes.
                        this.remountTokenizer();
                        this.openConfirmationModal = false;
                        this.pageSettings.loaded = true;
                        this.pageSettings.error =
                            "Card entry timed out, please re-enter the card";
                        this.toastRef.current.notifyError("Card entry timed out, please re-enter the card");
                    }
                    else {
                        this.resetProperties();
                        await this.populateOrder();
                        this.pageSettings.loaded = true;
                        this.tokenizerResetKey = Date.now();
                        this.toastRef.current.notifyError(declineText);
                    }
                    const logData = {
                        user: store_3.usersStore.user.value.id,
                        action: isApproved
                            ? `Payment has been completed of amount ${this.toUSD(payObj.payment.amountPaid)} via ${payObj.payment.method}.`
                            : "Payment has been declined due to invalid card credentials.",
                        category: store_3.LogCategory.payment,
                        categoryReferenceKey: this.order.id,
                        order: this.order.id,
                        site: this.order.site.id
                    };
                    await store_3.usersStore.createLog(logData);
                }
                else if ("error" in result) {
                    const code = result.error || "";
                    const errPayload = result.data;
                    const message = result.message ||
                        this.cardPaymentErrorMessage(code, errPayload === null || errPayload === void 0 ? void 0 : errPayload.retref);
                    this.pageSettings.loaded = true;
                    if (!["PAYMENT_IN_PROGRESS", "AMBIGUOUS_PAYMENT"].includes(code)) {
                        this.chargeIdempotencyKey = "";
                    }
                    // Gateway declines put resptext in `code`/`message`; remount tokenizer
                    // when CardSecure's ~2-minute token window has expired.
                    if (this.usesTokenizer &&
                        this.isExpiredTokenDecline(message + " " + code)) {
                        this.remountTokenizer();
                        const timedOut = "Card entry timed out, please re-enter the card";
                        this.pageSettings.error = timedOut;
                        this.toastRef.current.notifyError(timedOut);
                    }
                    else {
                        if (this.usesTokenizer) {
                            this.remountTokenizer();
                        }
                        this.pageSettings.error = message;
                        this.toastRef.current.notifyError(message);
                    }
                }
            }
            finally {
                this.cardPaymentSubmitting = false;
            }
        };
        this.newChargeIdempotencyKey = () => {
            if (typeof crypto !== "undefined" && crypto.randomUUID) {
                return crypto.randomUUID();
            }
            return `charge-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
        };
        this.cardPaymentErrorMessage = (code, retref) => {
            switch (code) {
                case "PAYMENT_RETRY":
                    return "Payment could not be processed — please try again.";
                case "GATEWAY_TIMEOUT":
                    return "The payment gateway timed out. Do not submit again until you verify whether the charge went through.";
                case "GATEWAY_ERROR":
                    return "The payment gateway is not responding. Please try again later.";
                case "AMBIGUOUS_PAYMENT":
                    return retref
                        ? `A prior attempt may have charged the card (ref ${retref}). Do not submit again — verify in CardPointe or contact support.`
                        : "A prior attempt may have charged the card. Do not submit again — verify in CardPointe or contact support.";
                case "PAYMENT_IN_PROGRESS":
                    return "This payment is already being processed. Please wait before submitting again.";
                case "COPAY_COLLECTION_DISABLED":
                    return "CardConnect patient payments are not enabled for this site.";
                case "MERCHANT_NOT_READY":
                    return "This pharmacy cannot accept card payments yet — check its CardConnect setup on the pharmacy's Financial tab.";
                case "PROFILE_NOT_FOUND":
                    return "This saved card does not belong to this patient and pharmacy.";
                case "TOKENIZER_REQUIRED":
                    return "New card payments must be entered in the secure CardPointe form.";
                case "MISSING_PERMISSION":
                    return "You do not have access to this pharmacy.";
                case "TOO_MUCH_CLAIMS":
                    return "Payment entered is larger than total price due on selected claims.";
                case "TOO_MUCH_ORDER":
                    return "Unable to process payment larger than balance due.";
                case "MISSING_IDEMPOTENCY_KEY":
                    return "Payment request could not be submitted. Please refresh and try again.";
                default:
                    return "Payment could not be completed. Please try again or contact support.";
            }
        };
        /**
         * this function handle Manual payment through credit card(manual payment) D-002
         * @param payObj IPaymentSubmission
         * @returns
         */
        this.handleManualPayment = async (payObj) => {
            if (this.pageSettings.error)
                return;
            const result = await store_2.paymentsStore.createPayment(payObj);
            if (result.success) {
                this.openConfirmationModal = false;
                this.resetProperties();
                await this.populateOrder();
                const logData = {
                    user: store_3.usersStore.user.value.id,
                    action: `Payment has been completed of amount ${this.toUSD(payObj.payment.amountPaid)} via ${payObj.payment.method}.`,
                    category: store_3.LogCategory.payment,
                    categoryReferenceKey: this.order.id,
                    order: this.order.id,
                    site: this.order.site.id
                };
                await store_3.usersStore.createLog(logData);
            }
            else {
                this.pageSettings.error = result.error;
            }
        };
        this.handleDelete = async (paymentId) => {
            this.deleteConfirmation = false;
            const result = await store_2.paymentsStore.deletePayment(paymentId);
            if (result.success) {
                const logData = {
                    user: store_3.usersStore.user.value.id,
                    action: `Payment has deleted.`,
                    category: store_3.LogCategory.payment,
                    categoryReferenceKey: paymentId,
                    order: this.order.id,
                    site: this.order.site.id
                };
                this.resetProperties();
                await this.populateOrder();
                await store_3.usersStore.createLog(logData);
            }
            else {
                this.pageSettings.error = result.error;
            }
        };
        /** D-002.840 — primary row for a shared gateway retref (multi-claim charge) */
        this.isPrimaryGatewayPayment = (row) => {
            var _a;
            if (!(row === null || row === void 0 ? void 0 : row.transaction))
                return false;
            const siblings = (((_a = this.order) === null || _a === void 0 ? void 0 : _a.payments) || []).filter((p) => p.transaction === row.transaction && p.orderId === row.orderId);
            if (!siblings.length)
                return false;
            return row.id === Math.min(...siblings.map((p) => p.id));
        };
        this.getGatewayRefundTotalCents = (row) => {
            var _a;
            if (!(row === null || row === void 0 ? void 0 : row.transaction))
                return (row === null || row === void 0 ? void 0 : row.amountPaid) || 0;
            return (((_a = this.order) === null || _a === void 0 ? void 0 : _a.payments) || [])
                .filter((p) => p.transaction === row.transaction && p.orderId === row.orderId)
                .reduce((sum, p) => sum + (p.amountPaid - (p.refundedAmount || 0)), 0);
        };
        this.canRefundPayment = (row) => {
            if (!this.allowCardConnectPatientPay)
                return false;
            if (!store_3.usersStore.permissions.RefundPatientPayment)
                return false;
            if (!(row === null || row === void 0 ? void 0 : row.transaction) || row.respStatus !== "A")
                return false;
            if (row.refundStatus === "refunded" ||
                row.refundStatus === "voided" ||
                row.refundStatus === "processing") {
                return false;
            }
            return this.isPrimaryGatewayPayment(row);
        };
        this.isReversedPayment = (row) => row.refundStatus === "refunded" ||
            row.refundStatus === "voided" ||
            (row.refundedAmount || 0) >= (row.amountPaid || 0);
        this.renderPaymentAmount = (row) => {
            const reversed = this.isReversedPayment(row);
            return (React.createElement("span", { className: reversed ? "payment__amount payment__amount--reversed" : "payment__amount" }, this.toUSD(row.amountPaid)));
        };
        this.renderPaymentStatusBadge = (row) => {
            if (row.refundStatus === "voided") {
                return (React.createElement("span", { className: "payment__status-badge payment__status-badge--voided" }, "Voided"));
            }
            if (row.refundStatus === "refunded") {
                return (React.createElement("span", { className: "payment__status-badge payment__status-badge--refunded" }, "Refunded"));
            }
            if (row.refundStatus === "processing") {
                return (React.createElement("span", { className: "payment__status-badge payment__status-badge--processing" }, "Processing\u2026"));
            }
            if (row.refundStatus === "failed") {
                return (React.createElement("span", { className: "payment__status-badge payment__status-badge--failed" }, "Refund failed"));
            }
            return null;
        };
        this.renderPaymentActions = (row) => {
            const statusBadge = this.renderPaymentStatusBadge(row);
            if (this.canRefundPayment(row)) {
                return (React.createElement("div", { className: "payment__table--actions" },
                    React.createElement(button_1.MaterialButton, { flat: true, className: "payment__action-refund", onClick: () => this.openRefundModal(row) }, "Refund")));
            }
            if (!row.transaction) {
                return (React.createElement("div", { className: "payment__table--actions" },
                    React.createElement(button_1.MaterialButton, { "data-tip": "Delete Payment", className: "payment__action-delete", flat: true, onClick: () => {
                            this.deleteConfirmation = true;
                            this.payRowId = row.id;
                        } },
                        React.createElement(icons_1.DeleteIcon, null))));
            }
            if (statusBadge) {
                return React.createElement("div", { className: "payment__table--actions" }, statusBadge);
            }
            return React.createElement("div", { className: "payment__table--actions" });
        };
        this.openRefundModal = (row) => {
            this.refundRowId = row.id;
            this.refundAmountCents = this.getGatewayRefundTotalCents(row);
            this.refundConfirmation = true;
        };
        this.handleRefund = async () => {
            if (!this.refundRowId)
                return;
            const paymentId = this.refundRowId;
            this.refundConfirmation = false;
            this.pageSettings.loaded = false;
            const idempotencyKey = `refund-${paymentId}-${Date.now()}`;
            const result = await store_2.paymentsStore.refundCardPayment(paymentId, idempotencyKey);
            this.pageSettings.loaded = true;
            this.refundRowId = null;
            this.refundAmountCents = 0;
            if (result.success) {
                const refundData = result.data;
                this.toastRef.current.notifySuccess(refundData.resptext || "Refund completed successfully.");
                this.resetProperties();
                await this.populateOrder();
                const logData = {
                    user: store_3.usersStore.user.value.id,
                    action: `CardConnect refund of ${this.toUSD(refundData.amount || 0)} processed.`,
                    category: store_3.LogCategory.payment,
                    categoryReferenceKey: paymentId,
                    order: this.order.id,
                    site: this.order.site.id
                };
                await store_3.usersStore.createLog(logData);
            }
            else if ("error" in result) {
                this.toastRef.current.notifyError(result.message || result.error || "Refund could not be completed.");
            }
        };
        /** D-002.74 — pharmacy site timezone (fallback Eastern). */
        this.getSiteTimezone = () => { var _a, _b; return ((_b = (_a = this.order) === null || _a === void 0 ? void 0 : _a.site) === null || _b === void 0 ? void 0 : _b.timezone) || "America/New_York"; };
        /** D-002.74 — Date Paid in site TZ with time (fixes UTC day-before display). */
        this.formatDatePaid = (datePaid) => {
            if (!datePaid)
                return "";
            return moment
                .tz(datePaid, this.getSiteTimezone())
                .format("MM/DD/YYYY");
        };
        this.toUSD = (input) => {
            const options = { currency: "USD", style: "currency" };
            const decimalStr = (input / 100).toFixed(2);
            const decimalNum = Number(decimalStr);
            const usd = decimalNum.toLocaleString("en-US", options);
            return usd;
        };
        this.renderDetail = () => {
            if (!this.pageSettings.loaded) {
                return (React.createElement("div", { style: { display: "float", left: "50%", top: "50%" } },
                    React.createElement(loading_indicator_1.UiLoadingIndicator, null)));
            }
            return this.chargeClaims.map((claim, i) => {
                const { fillNumber, inventory, quantity, rxId } = claim;
                const totalDue = patient_payment_balance_1.getClaimAmountDueCents(claim);
                const payments = this.order.payments
                    .filter((payment) => payment.claimId === claim.id)
                    .slice()
                    .sort((a, b) => {
                    return (b.id || 0) - (a.id || 0);
                });
                const totalPaid = payments.reduce((acc, cur) => acc + (cur.amountPaid - (cur.refundedAmount || 0)), 0);
                return (React.createElement("div", { className: "payment__card", key: i },
                    React.createElement("div", { className: "payment__card__title" },
                        React.createElement("span", null, rxId === null || rxId === void 0 ? void 0 :
                            rxId.rxIdUnique,
                            "-",
                            fillNumber,
                            " ",
                            inventory.name,
                            " (",
                            quantity,
                            ")"),
                        React.createElement("span", null, totalPaid < totalDue
                            ? `${this.toUSD(totalDue - totalPaid)} Due`
                            : "Paid")),
                    this.renderTable(payments)));
            });
        };
        this.renderBill = () => {
            if (!this.pageSettings.loaded)
                return React.createElement(loading_indicator_1.UiLoadingIndicator, null);
            return (React.createElement("div", { className: "payment__header__content" },
                React.createElement("div", { className: "payment__section-title" }, "Order Summary"),
                React.createElement("div", { className: "payment__summary-list" }, this.chargeClaims.map((claim, i) => {
                    const { fillNumber, inventory, quantity, rxId } = claim;
                    const dispPrice = patient_payment_balance_1.getClaimAmountDueCents(claim);
                    return (React.createElement("div", { className: "payment__summary-row", key: i },
                        React.createElement("span", { className: "payment__summary-row__label" },
                            React.createElement("b", null, `${i + 1}.`),
                            " ",
                            `#${rxId === null || rxId === void 0 ? void 0 : rxId.rxIdUnique}-${fillNumber} — ${inventory.name} (Qty: ${quantity})`),
                        React.createElement("span", { className: "payment__summary-row__amount" }, this.toUSD(dispPrice))));
                })),
                React.createElement("div", { className: "payment__summary-totals" },
                    React.createElement("div", { className: "payment__summary-totals__row payment__summary-totals__row--strong" },
                        React.createElement("span", null, "Total Cost"),
                        React.createElement("span", null, this.toUSD(this.balance.total))),
                    React.createElement("div", { className: "payment__summary-totals__row payment__summary-totals__row--strong" },
                        React.createElement("span", null, "Balance Paid"),
                        React.createElement("span", null, this.toUSD(this.balance.paid))),
                    React.createElement("div", { className: "payment__summary-totals__row payment__summary-totals__row--due" },
                        React.createElement("span", null, "Balance Due"),
                        React.createElement("span", null, this.toUSD(this.balance.due))))));
        };
        // Add the paymentoutstanding-table css D-002.839
        this.renderTable = (data) => (React.createElement("div", { className: "payment__table cstmPayment__table paymentoutstanding-table" },
            React.createElement(list_1.MaterialList, { resizableheader: true, columns: getPaymentTableColumns(this.allowCardConnectPatientPay), order: "ASC", orderBy: "claim", rows: data, renderRow: this.renderTableRow })));
        // Add the List for Notes //D-002.839
        this.renderTableRow = (row, i) => row && (React.createElement(list_item_1.MaterialListItem, { className: "payment__table--row", key: i },
            React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__col payment__col--type", primary: row.method || "" }),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__col payment__col--date", primary: this.formatDatePaid(row.datePaid) }),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__table--amount payment__col payment__col--amount", primary: this.renderPaymentAmount(row) }),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__col payment__col--card", primary: row.cardEnding || "" }),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__col payment__col--txn", primary: row.transaction || "" }),
            !this.allowCardConnectPatientPay && (React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__col payment__col--response", primary: row.responseEnding || "" })),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__col payment__col--check", primary: row.checkNumber || "" }),
            React.createElement(list_item_text_1.MaterialListItemText, { className: "payment__table--item payment__col payment__col--notes", primary: row.notes || "" }),
            this.renderPaymentActions(row)));
        //D-002
        this.renderPayment = () => {
            var _a, _b, _c, _d, _e;
            let shouldDisableButtons;
            const { cardholdername, cardnumber, expiry, cvc, billingPostal, focus, saveCard, nickName } = this.state;
            const { checkNumber } = this.payment;
            const hasValidBillingPostal = /^\d{5}(\d{4})?$/.test(billingPostal || "");
            //D-002.56 cvc.length == 4
            if (this.payment.method === payment_1.PaymentMethod.credit &&
                this.allowCardConnectPatientPay) {
                if (this.patProfileId != "0") {
                    shouldDisableButtons =
                        cardholdername.length &&
                            hasValidBillingPostal &&
                            (this.cardTypeName == "AMEX" ? cvc.length == 4 : cvc.length == 3)
                            ? false
                            : true;
                }
                else {
                    // D-002 Phase 3 — require tokenized card + name + ZIP (no PAN digit counts)
                    shouldDisableButtons = !(cardholdername.length &&
                        !!this.state.cardToken &&
                        hasValidBillingPostal &&
                        !this.state.tokenizerError);
                }
            }
            else if (this.payment.method === payment_1.PaymentMethod.check) {
                shouldDisableButtons = (this.payment.checkNumber || "").length
                    ? false
                    : true;
            }
            else if (this.payment.method === payment_1.PaymentMethod.cash) {
                shouldDisableButtons = false;
            }
            else if (this.payment.method === payment_1.PaymentMethod.credit &&
                !this.allowCardConnectPatientPay) {
                shouldDisableButtons = false;
            }
            // D-002.592 — block submit until Total to Apply matches Amount Paid
            if (this.needsManualAllocation && !this.isAllocationComplete) {
                shouldDisableButtons = true;
            }
            return (React.createElement("div", { className: "payment__new__wrapper" },
                !this.pageSettings.showPay && !this.balance.complete && (React.createElement(button_1.MaterialButton, { className: "payment__add-btn", secondary: true, onClick: async () => {
                        this.pageSettings.showPay = true;
                        this.pageSettings.firstLoad = true; //D-002.9051
                    } }, "Add New Payment")),
                this.pageSettings.showPay && (React.createElement("div", { className: "payment__new" },
                    React.createElement(form_1.UiForm, { className: "payment__checkout-form", submitClassName: "payment__submit-btn", buttons: [
                            React.createElement(button_1.MaterialButton, { key: "payment-cancel", className: "btnCancel", onClick: () => {
                                    this.pageSettings.showPay = false;
                                    this.setState({
                                        cardnumber: "",
                                        cardholdername: "",
                                        expiry: "",
                                        cvc: "",
                                        focus: false,
                                        saveCard: false,
                                        nickName: "",
                                        cardToken: "",
                                        tokenizerError: ""
                                    });
                                    this.patProfileId = "0";
                                    this.tokenizerResetKey = Date.now();
                                } }, "Cancel"),
                            "Submit Payment"
                        ], shouldDisableSave: shouldDisableButtons, id: "auth-forgot-password-form", onSubmit: async () => this.handleConfirmationPopUp(), loading: false, error: this.pageSettings.error },
                        !this.pageSettings.loaded && (React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "payment-center" })),
                        React.createElement("div", { className: "payment__new__general" },
                            React.createElement("div", { className: "payment__section" },
                                React.createElement("div", { className: "payment__section-title" }, "Payment Details"),
                                React.createElement("div", { className: "payment__fields-grid" },
                                    React.createElement(select_1.MaterialSelect, { className: "payment__new--select", options: this.availableMethods, required: true, label: "Payment Type", onSelect: this.handleOnSelect, value: this.payment.method }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "payment__new--amount", label: "Amount Paid", required: true, autoFocus: true, placeholder: this.toUSD(this.balance.due).replace("$", ""), leftItem: React.createElement(icons_1.DollarsIcon, null), onChange: this.handleChangeNumber, value: this.payment.amountPaid || "" }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "payment__new--date", label: "Date of Payment", required: true, disabled: true, value: moment.tz(this.getSiteTimezone()).format("MM/DD/YYYY") })),
                                this.payment.method === payment_1.PaymentMethod.check && (React.createElement("div", { className: "payment__fields-grid payment__fields-grid--single" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "payment__new--response", label: "Check Number", onChange: (_, v) => {
                                            this.payment.checkNumber = v;
                                        }, value: (_a = this.payment.checkNumber) !== null && _a !== void 0 ? _a : "" })))),
                            this.payment.method === payment_1.PaymentMethod.credit &&
                                this.allowCardConnectPatientPay &&
                                this.patCardProfile.length > 0 && (React.createElement("div", { className: "payment__section" },
                                React.createElement("div", { className: "payment__section-title" }, "Saved Card"),
                                React.createElement("div", { className: "payment__saved-card-row" },
                                    React.createElement(select_1.MaterialSelect, { className: "payment__new--select", options: this.availablePatProfile, required: true, label: "Saved Cards", onSelect: this.handlePrfOnSelect, value: this.patProfileId }),
                                    this.patProfileId != "0" && (React.createElement(React.Fragment, null,
                                        React.createElement(button_1.MaterialButton, { className: "payment__add-card-btn", secondary: true, disabled: this.cardPaymentSubmitting, onClick: this.resetSavedCardSelection }, "+ Use New Card"),
                                        React.createElement(button_1.MaterialButton, { className: "payment__remove-card-btn", disabled: this.cardPaymentSubmitting, onClick: this.openSavedCardDeleteModal },
                                            React.createElement(icons_1.DeleteIcon, { fill: "currentColor" }),
                                            "Remove Card")))))),
                            this.payment.method === payment_1.PaymentMethod.credit &&
                                this.allowCardConnectPatientPay && (React.createElement("div", { className: "payment__section" },
                                React.createElement("div", { className: "payment__section-title" }, "Card Information"),
                                React.createElement("div", { className: this.usesTokenizer
                                        ? "paymentForm paymentForm--tokenizer"
                                        : "paymentForm" },
                                    !this.usesTokenizer && (React.createElement("div", { className: "paymentForm__preview" },
                                        React.createElement(react_credit_cards_1.default, { number: cardnumber, name: cardholdername, expiry: expiry, cvc: cvc, focused: focus }))),
                                    React.createElement("div", { className: this.usesTokenizer
                                            ? "formCard formCard--tokenizer"
                                            : "formCard" },
                                        React.createElement("div", null, this.usesTokenizer ? (React.createElement(React.Fragment, null,
                                            this.ccTokenizerIframeUrl ? (React.createElement(cc_tokenizer_frame_1.CcTokenizerFrame, { iframeUrl: this.ccTokenizerIframeUrl, resetKey: this.tokenizerResetKey, onToken: (token) => this.setState({
                                                    cardToken: token,
                                                    tokenizerError: ""
                                                }), onClearToken: () => this.setState({ cardToken: "" }), onError: (message) => this.setState({
                                                    tokenizerError: message,
                                                    cardToken: ""
                                                }) })) : (React.createElement("div", { className: "payment__tokenizer-error", role: "alert" }, "Secure card entry is unavailable. Contact support before taking a card payment.")),
                                            React.createElement("div", { className: "payment__card-field" },
                                                React.createElement("label", { className: "payment__card-field-label", htmlFor: "payment-card-holder" }, "Name on Card"),
                                                React.createElement("input", { id: "payment-card-holder", type: "text", name: "cardholdername", autoComplete: "off", placeholder: "As printed on the card", value: cardholdername, onChange: e => this.handleChange(e), onFocus: e => this.setFocus(e), className: "payment__card-input" })),
                                            React.createElement("div", { className: "payment__card-field payment__card-field--zip" },
                                                React.createElement("label", { className: "payment__card-field-label", htmlFor: "payment-billing-postal" }, "Billing ZIP"),
                                                React.createElement("input", { id: "payment-billing-postal", type: "tel", name: "billingPostal", maxLength: 9, autoComplete: "postal-code", placeholder: "12345", value: billingPostal, onChange: e => this.handleChange(e), className: "payment__card-input" })),
                                            React.createElement("div", { className: "saveCardBox" },
                                                React.createElement(checkbox_1.MaterialCheckbox, { onAction: (e) => this.handleSaveCard(e), label: "Save card (patient consent obtained)", checked: saveCard }),
                                                saveCard && (React.createElement("input", { type: "text", name: "nickName", className: "payment__card-input saveCardBox__nickname", placeholder: "Nickname (optional)", value: nickName, onChange: e => this.handleChange(e), onFocus: e => this.setFocus(e) }))))) : (React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "payment__card-field" },
                                                React.createElement("label", { className: "payment__card-field-label", htmlFor: "payment-card-number" }, "Card Number"),
                                                React.createElement("input", { id: "payment-card-number", type: "text", name: "cardnumber", placeholder: "1234 5678 9012 3456", autoComplete: "off", autoSave: "false", value: cardnumber, disabled: true, className: "payment__card-input disbleinput" })),
                                            React.createElement("div", { className: "payment__card-field" },
                                                React.createElement("label", { className: "payment__card-field-label", htmlFor: "payment-card-holder" }, "Name on Card"),
                                                React.createElement("input", { id: "payment-card-holder", type: "text", name: "cardholdername", autoComplete: "off", placeholder: "As printed on the card", value: cardholdername, disabled: true, className: "payment__card-input disbleinput" })),
                                            React.createElement("div", { className: "expiryInput" },
                                                React.createElement("div", { className: "payment__card-field" },
                                                    React.createElement("label", { className: "payment__card-field-label", htmlFor: "payment-card-expiry" }, "Expires"),
                                                    React.createElement("input", { id: "payment-card-expiry", type: "text", name: "expiry", className: "disbaleExpiry", autoComplete: "off", placeholder: "MM/YY", value: expiry, disabled: true })),
                                                React.createElement("div", { className: "payment__card-field" },
                                                    React.createElement("label", { className: "payment__card-field-label", htmlFor: "payment-card-cvc" }, "CVC"),
                                                    React.createElement("input", { id: "payment-card-cvc", type: "tel", name: "cvc", maxLength: this.cardTypeName == "AMEX" ? 4 : 3, className: "expirycvv", placeholder: this.cardTypeName == "AMEX" ? "1234" : "123", autoComplete: "off", value: cvc, onChange: e => this.handleChange(e), onFocus: e => this.setFocus(e) })),
                                                React.createElement("div", { className: "payment__card-field" },
                                                    React.createElement("label", { className: "payment__card-field-label", htmlFor: "payment-billing-postal" }, "Billing ZIP"),
                                                    React.createElement("input", { id: "payment-billing-postal", type: "tel", name: "billingPostal", maxLength: 9, autoComplete: "postal-code", placeholder: "12345", value: billingPostal, onChange: e => this.handleChange(e), className: "expirycvv" })))))))))),
                            this.payment.method === payment_1.PaymentMethod.credit &&
                                !this.allowCardConnectPatientPay && (React.createElement("div", { className: "payment__section" },
                                React.createElement("div", { className: "payment__section-title" }, "Card Details (Manual)"),
                                React.createElement("div", { className: "payment__fields-grid" },
                                    React.createElement(select_1.MaterialSelect, { className: "payment__new--card-type", options: this.availableCards, required: true, label: "Card Type", onSelect: (e) => {
                                            this.payment.cardType = e;
                                        }, value: (_b = this.payment.cardType) !== null && _b !== void 0 ? _b : payment_1.CardType.visa }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "payment__new--digits", label: "Last 4 Digits of Card", onChange: (_, v) => {
                                            if (v.length <= 4)
                                                this.payment.cardEnding = v.replace(/\s/g, "");
                                        }, value: (_c = this.payment.cardEnding) !== null && _c !== void 0 ? _c : "" }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "payment__new--response", label: "Response Ending", onChange: (_, v) => {
                                            this.payment.responseEnding = v;
                                        }, value: (_d = this.payment.responseEnding) !== null && _d !== void 0 ? _d : "" })))),
                            React.createElement("div", { className: "payment__section payment__new__claims" },
                                React.createElement("p", { className: "payment__claims-question" }, "Which claims are associated with this payment?"),
                                React.createElement("div", { className: `payment__claims-header${this.needsManualAllocation
                                        ? " payment__claims-header--allocate"
                                        : ""}` },
                                    React.createElement("span", null, "Claim"),
                                    this.needsManualAllocation && React.createElement("span", null, "Amount to Apply"),
                                    React.createElement("span", null, "Notes")), (_e = (this.chargeClaims || [])) === null || _e === void 0 ? void 0 :
                                _e.map((claim, i) => {
                                    const { rxId } = claim;
                                    const claimPayments = this.order.payments.filter((payment) => payment.claimId === claim.id);
                                    const claimDueCents = patient_payment_balance_1.getClaimAmountDueCents(claim);
                                    const totalPaid = claimPayments.reduce((acc, cur) => acc + patient_payment_balance_1.netPaymentAmountCents(cur), 0);
                                    const totalDue = claimDueCents - totalPaid;
                                    const isPaid = totalDue <= 0;
                                    let label = `#${rxId === null || rxId === void 0 ? void 0 : rxId.rxIdUnique}-${claim.fillNumber} — ${claim.inventory.name} (Qty: ${claim.quantity})`;
                                    label += isPaid
                                        ? " — PAID"
                                        : ` — ${this.toUSD(totalDue)} Due`;
                                    if (this.pageSettings.firstLoad && !isPaid) {
                                        this.claims.add(claim.id);
                                        if (i + 1 === this.chargeClaims.length) {
                                            this.pageSettings.firstLoad = false;
                                        }
                                    }
                                    return (React.createElement("div", { className: `payment__claim-row${this.needsManualAllocation
                                            ? " payment__claim-row--allocate"
                                            : ""}`, key: claim.id },
                                        React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => this.handleCheckbox(claim.id), label: label, checked: this.claims.has(claim.id), disabled: isPaid }),
                                        this.needsManualAllocation && (React.createElement("input", { className: `payment__claim-amount${this.isClaimAmountInvalid(claim.id)
                                                ? " payment__claim-amount--invalid"
                                                : ""}`, type: "text", inputMode: "decimal", autoComplete: "off", placeholder: "$XX.XX", value: this.claims.has(claim.id)
                                                ? this.claimAmounts[claim.id] || ""
                                                : "", onChange: (e) => this.handleClaimAmountChange(claim.id, e.target.value), onBlur: () => this.handleClaimAmountBlur(claim.id), disabled: !this.claims.has(claim.id) || isPaid })),
                                        React.createElement("input", { className: "payment__claim-notes", type: "text", autoComplete: "off", placeholder: "Notes (optional)", value: this.claims.has(claim.id) ? this.paymentNotes[claim.id] || '' : '', onChange: (e) => this.handleInputChange(claim.id, e.target.value), disabled: !this.claims.has(claim.id) })));
                                }),
                                this.needsManualAllocation && (React.createElement("div", { className: "payment__claim-row payment__claim-row--allocate payment__claim-total" },
                                    React.createElement("span", { className: "payment__claim-total-label" }, "Total to Apply"),
                                    React.createElement("span", { className: "payment__claim-total-value" }, this.toUSD(this.totalApplyCents)),
                                    React.createElement("span", null)))))),
                    this.openConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit Payment", cancelText: "Cancel", message: `Please confirm. <br />Do you want to submit a request for payment?`, onCancel: () => {
                            this.openConfirmationModal = false;
                        }, onConfirm: this.handleSubmit, title: "Payment Request" }))))));
        };
        this.renderOrder = () => {
            if (!this.pageSettings.loaded)
                return React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "payment-center" });
            const balanceStatus = this.balance.complete ? "complete" : "outstanding";
            // ToastNotification D-002
            // Add the payment-outstanding css D-002.839
            return (React.createElement("div", { className: "payment__order payment-outstanding" },
                React.createElement(tostify_alert_1.default, { ref: this.toastRef }),
                React.createElement("div", { className: "payment__header" },
                    React.createElement("div", { className: "payment__header__banner" },
                        React.createElement("div", { className: `payment__header__status status--${balanceStatus}` }, this.balance.complete ? "Payment Complete" : "Payment Outstanding"),
                        !this.balance.complete && (React.createElement("div", { className: "payment__header__balance-due" },
                            React.createElement("span", { className: "payment__header__balance-due-label" }, "Balance Due"),
                            React.createElement("span", { className: "payment__header__balance-due-amount" }, this.toUSD(this.balance.due))))),
                    this.renderBill()),
                this.renderPayment(),
                React.createElement("div", { className: "payment__detail__wrapper", ref: el => {
                        this.paymentTablesEl = el;
                    } }, this.renderDetail()),
                this.deleteConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete", cancelText: "Cancel", message: `Please confirm. <br />Do you want to delete this payment?`, onCancel: () => { this.deleteConfirmation = false; }, onConfirm: async () => this.handleDelete(this.payRowId), title: "Delete Payment" })),
                this.savedCardDeleteConfirmation && this.savedCardToDelete && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: this.savedCardDeleteSubmitting ? "Removing..." : "Remove Card", cancelText: "Cancel", message: this.savedCardDeleteMessage(), onCancel: this.closeSavedCardDeleteModal, onConfirm: this.handleSavedCardDelete, shouldDisableConfirm: this.savedCardDeleteSubmitting, title: "Remove Saved Card" })),
                this.refundConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm Refund", cancelText: "Cancel", message: `Please confirm. <br />Refund <b>${this.toUSD(this.refundAmountCents)}</b> to the patient's card? This cannot be undone from this screen.`, onCancel: () => {
                        this.refundConfirmation = false;
                        this.refundRowId = null;
                        this.refundAmountCents = 0;
                    }, onConfirm: this.handleRefund, title: "Refund Payment" }))));
        };
        /**
         * D-002.611 function is used to initaiate a mail with payment receipt attached
         * @param type
         */
        this.sendPdfEmail = async (type) => {
            this.showModal = false;
            const dispensedClaims = this.order.claims.filter((clm) => clm.status === claim_1.ClaimStatus.Dispensed);
            this.pageSettings.loaded = false;
            await store_1.ordersStore.receiptPdfFile(dispensedClaims, type, this.query);
            this.pageSettings.loaded = true;
            if (this.checked)
                await this.handlePatinetEmailUpdate();
            this.toastRef.current.notifySuccess(this.checked
                ? "Patient email updated and Payment receipt email sent successfully."
                : "Payment receipt email sent successfully.");
        };
        /**
         * D-002.611 responsibl to update the patient profile, based on checkbox
         */
        this.handlePatinetEmailUpdate = async () => {
            var _a, _b;
            const patientId = (_b = (_a = this.order) === null || _a === void 0 ? void 0 : _a.patient) === null || _b === void 0 ? void 0 : _b.id;
            await store_4.patientsStore.readPatient(patientId);
            if (this.checked) {
                store_4.patientsStore.patient.value["email"] = this.query.email;
                const patientData = store_4.patientsStore.patient.value;
                await store_4.patientsStore.savePatient(patientData, null);
            }
        };
        /**
         * D-002.60 for print the pdf invoice type = 'receipt'
         * @param type
         */
        this.printLabelsClickHandler = async (type) => {
            var _a;
            const dispensedClaims = (_a = this.order) === null || _a === void 0 ? void 0 : _a.claims.filter((clm) => clm.status === claim_1.ClaimStatus.Dispensed);
            // .map((clm: IClaim) => clm.id);
            this.printModal = true;
            await store_1.ordersStore.print(dispensedClaims, type);
            const logData = {
                user: store_3.usersStore.user.value.id,
                action: `Clicked "print ${type} of payment".`,
                category: store_3.LogCategory.payment,
                categoryReferenceKey: this.order.id,
                order: this.order.id,
                site: this.order.site.id
            };
            await store_3.usersStore.createLog(logData);
        };
        /**
         * D-002.611 open model pop upand get the pat info
         */
        this.emailReceiptBtn = async () => {
            var _a, _b;
            dummyQuery.email = this.order.patient.email || "";
            dummyQuery.patName =
                this.order.patient.firstName + " " + this.order.patient.lastName || "";
            dummyQuery.siteName = ((_b = (_a = this.order) === null || _a === void 0 ? void 0 : _a.site) === null || _b === void 0 ? void 0 : _b.name) || "TMP Pharmacy";
            this.query = dummyQuery;
            this.showModal = true;
        };
        //D-002.611
        this.openEmailConfirmationPopup = () => {
            const modalButtons = [
                React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => {
                        this.query = dummyQuery;
                        this.showModal = false;
                    } }, "Cancel"),
                React.createElement(button_1.MaterialButton, { onClick: async () => this.sendPdfEmail("receipt"), primary: true, style: { marginLeft: "1em" }, disabled: !this.query.email || this.isValidEmail }, this.checked ? "Update & Send Email" : "Send Email")
            ];
            return (React.createElement(modal_1.Modal, { buttons: modalButtons, onCancel: () => {
                    this.showModal = false;
                }, top: "25%", width: "26em" },
                React.createElement("div", null,
                    React.createElement("div", { style: { marginBottom: "20px" } },
                        React.createElement("span", { className: "popupHeading" }, "Please verify your email"),
                        " ",
                        React.createElement("br", null)),
                    React.createElement("div", null,
                        !this.query.email && (React.createElement("span", { className: "warnText" }, "Patient associate email was not found")),
                        " ",
                        React.createElement(text_field_1.MaterialTextField, { label: "Confirmation Email", onChange: this.validateEmail, value: String(this.query.email) }),
                        this.isValidEmail && (React.createElement("span", { className: "warnText" }, this.query.email.length ? "Must enter a valid Email." : ""))),
                    (!this.query.email ||
                        this.query.email != this.order.patient.email) && (React.createElement("div", { className: "emailPopUpdiv" },
                        React.createElement("input", { 
                            // checked={this.checked}
                            type: "checkbox", onChange: this.handlePopUpCheckbox }),
                        React.createElement("span", { className: "" },
                            "Would you like to update email on patient profile ?",
                            " "))))));
        };
        /**
         * D-002.60 add footer for button print receipt in payment page
         * @returns
         */
        this.renderFooter = () => {
            if (!store_1.ordersStore.order.value)
                return;
            return (React.createElement("div", { className: "orders-detail__footer" },
                React.createElement(toolbar_1.MaterialToolBar, null,
                    React.createElement(React.Fragment, null,
                        React.createElement(button_1.MaterialButton, { primary: true, onClick: () => this.printLabelsClickHandler("receipt") }, "Print Receipt"),
                        React.createElement(button_1.MaterialButton, { primary: true, onClick: () => this.emailReceiptBtn() }, "Email Receipt"))),
                this.renderModalPrint(),
                this.showModal && this.openEmailConfirmationPopup()));
        };
        this.calculateBalance = () => {
            const { totalDueCents, totalPaidCents, complete } = patient_payment_balance_1.computeOrderPaymentBalance(this.chargeClaims, this.order.payments);
            this.balance = {
                complete,
                due: totalDueCents - totalPaidCents,
                paid: totalPaidCents,
                total: totalDueCents
            };
        };
        //D-002.839
        this.handleCheckbox = (claimId) => {
            if (this.claims.has(claimId)) {
                this.claims.delete(claimId);
                this.paymentNotes[claimId] = '';
                delete this.paymentNotes[claimId];
                delete this.claimAmounts[claimId];
                this.claimAmounts = Object.assign({}, this.claimAmounts);
            }
            else {
                this.claims.add(claimId);
            }
            this.forceUpdate();
        };
        //D-002.839
        this.handleInputChange = (claimId, value) => {
            this.paymentNotes[claimId] = value;
            this.forceUpdate();
        };
        /**
         * D-002.611 handle pop up checkbox to update email on pat profile
         * @param e
         */
        this.handlePopUpCheckbox = (e) => {
            this.checked = e.target.checked;
        };
        /**
         * D-002.611 validate email while enterd on the box to send payment
         * receipt
         * @param e
         */
        this.validateEmail = async (e) => {
            var _a;
            this.query.email = e.target.value;
            const validEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
            if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.value) && e.target.value.match(validEmail)) {
                this.isValidEmail = false;
            }
            else {
                this.isValidEmail = true;
            }
        };
        //D-002
        this.resetProperties = () => {
            this.pageSettings.loaded = false;
            this.pageSettings.showPay = false;
            this.payment = this.dummyPayment;
            this.claims.clear();
            this.claimAmounts = {};
            this.chargeIdempotencyKey = "";
            this.cardPaymentSubmitting = false;
            this.pageSettings.error = "";
            this.setState({
                cardnumber: "",
                cardholdername: "",
                expiry: "",
                cvc: "",
                acctId: "",
                focus: false,
                saveCard: false,
                nickName: "",
                cardToken: "",
                tokenizerError: ""
            });
            this.patProfileId = "0";
            this.cardTypeName = "";
            this.savedCardDeleteConfirmation = false;
            this.savedCardDeleteSubmitting = false;
            this.savedCardToDelete = null;
            this.tokenizerResetKey = Date.now();
        };
        // D-002.60
        this.closePrintPreview = () => {
            this.printModal = false;
        };
        // D-002.60
        this.renderModalPrint = () => this.printModal && (React.createElement("div", { className: "pdf-container" },
            React.createElement("div", { className: "pdf-item" },
                !store_1.ordersStore.pdfPreview && (React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "pdfloader" })),
                store_1.ordersStore.pdfPreview && (React.createElement("iframe", { className: "iframe-style", src: store_1.ordersStore.pdfPreview || "/defaultPDF.pdf" }))),
            React.createElement(button_1.MaterialButton, { secondary: true, onClick: () => this.closePrintPreview() }, "Close")));
        this.state = {
            cardnumber: "",
            tokenizedNumber: "",
            cardholdername: "",
            expiry: "",
            cvc: "",
            billingPostal: normalizeBillingPostal((_b = (_a = props.order) === null || _a === void 0 ? void 0 : _a.patient) === null || _b === void 0 ? void 0 : _b.zip),
            focus: false,
            saveCard: false,
            nickName: "",
            acctId: "",
            cardToken: "",
            tokenizerError: ""
        };
    }
    /**
     * D-002.53 get all the available or saved card profile
     */
    get availablePatProfile() {
        var _a;
        return ((_a = this.patCardProfile) !== null && _a !== void 0 ? _a : []).map((profile, i) => ({
            id: i,
            label: `${profile.acctType}/${"*****" + profile.cardEnding} / ${profile.nickname ? profile.nickname : ""}`,
            value: profile.profileId
        }));
    }
    async componentDidMount() {
        document.addEventListener("mousedown", this.rememberPaymentColumnDrag, true);
        document.addEventListener("mouseup", this.syncPaymentColumnWidths);
        await this.populateOrder();
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.rememberPaymentColumnDrag, true);
        document.removeEventListener("mouseup", this.syncPaymentColumnWidths);
        this.resetProperties();
        this.order = null;
    }
    /** D-002.592 — show Amount to Apply when paying less than order balance due */
    get needsManualAllocation() {
        if (!this.balance)
            return false;
        const paidCents = patient_payment_balance_1.dollarsToCents(this.payment.amountPaid);
        return paidCents > 0 && paidCents < this.balance.due;
    }
    get totalApplyCents() {
        let sum = 0;
        for (const claimId of Array.from(this.claims)) {
            const raw = this.claimAmounts[claimId];
            if (raw == null || raw === "" || String(raw).endsWith("."))
                continue;
            sum += patient_payment_balance_1.dollarsToCents(raw);
        }
        return sum;
    }
    /** True when every entered Amount to Apply is ≥ $0.01 and ≤ claim due / Amount Paid. */
    get hasValidClaimAmounts() {
        if (!this.needsManualAllocation)
            return true;
        const paidCents = patient_payment_balance_1.dollarsToCents(this.payment.amountPaid);
        for (const claim of this.chargeClaims || []) {
            if (!this.claims.has(claim.id))
                continue;
            const raw = this.claimAmounts[claim.id];
            if (raw == null || raw === "" || String(raw).endsWith("."))
                continue;
            const amountCents = patient_payment_balance_1.dollarsToCents(raw);
            const maxCents = Math.min(this.getClaimRemainingDueCents(claim), paidCents);
            if (amountCents < 1 || amountCents > maxCents)
                return false;
        }
        return true;
    }
    get isAllocationComplete() {
        if (!this.needsManualAllocation)
            return true;
        const paidCents = patient_payment_balance_1.dollarsToCents(this.payment.amountPaid);
        return (this.hasValidClaimAmounts &&
            this.totalApplyCents === paidCents &&
            paidCents > 0);
    }
    /** D-002 Phase 3 — every new CardConnect card uses the Hosted iFrame Tokenizer. */
    get usesTokenizer() {
        return (this.patProfileId === "0" &&
            this.payment.method === payment_1.PaymentMethod.credit &&
            this.allowCardConnectPatientPay);
    }
    /**
     * D-002 handle input fields on change
     * @param e
     * @returns
     */
    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        const type = e.target.name;
        let value = e.target.value;
        if (type === "cvc") {
            value = value.replace(/\D/g, "");
            this.setState({ [type]: value });
        }
        else if (type === "billingPostal") {
            this.setState({ [type]: normalizeBillingPostal(value) });
        }
    }
    /**
    * D-002 make a focus
    */
    setFocus(e) {
        this.setState({
            focus: e.target.name ? true : false
        });
    }
    /**
     * call order and footer renders
     * @returns
     */
    render() {
        return (React.createElement("div", { className: "payment__wrapper" },
            this.renderOrder(),
            this.renderFooter()));
    }
};
/** Non-negative money: digits + optional . and up to 2 decimals (no negatives). */
PaymentTab.MONEY_INPUT_REGEX = /^\d*(\.\d{0,2})?$/;
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "claims", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "paymentNotes", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "claimAmounts", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "chargeClaims", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "patCardProfile", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "patProfileId", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "payment", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "balance", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "openConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "checked", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "isValidEmail", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "showModal", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "deleteConfirmation", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "payRowId", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "refundConfirmation", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "refundRowId", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "refundAmountCents", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "savedCardDeleteConfirmation", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "savedCardDeleteSubmitting", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "savedCardToDelete", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "cardTypeName", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "allowCardConnectPatientPay", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "ccTokenizerIframeUrl", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "tokenizerResetKey", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "chargeIdempotencyKey", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "cardPaymentSubmitting", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "query", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "printModal", void 0);
__decorate([
    mobx_1.observable
], PaymentTab.prototype, "pageSettings", void 0);
PaymentTab = PaymentTab_1 = __decorate([
    mobx_react_1.observer
], PaymentTab);
exports.PaymentTab = PaymentTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/tabs/payment/payment.tsx
// module id = 3385
// module chunks = 0